module.exports = __webpack_public_path__ + "img/refrigeracion.00c25009.png";